import React, { Fragment, useState } from "react";
import Breadcrumb from "../../common/breadcrumb";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Media,
  Row,
} from "reactstrap";
import { ToastContainer, toast } from "react-toastify";
import { makeStyles } from "@mui/styles";
import AgeingReportModal from "./ageingReportModal";
import CommonTable from "../../common/commonTable";
import {
  agingReportbyPaymentClassTableData,
  agingReportbyPaymentClassTableDataMain,
  agingReportbyPaymentClassTableHeader,
  agingReportbyPaymentClassTableHeaderMain,
} from "../../common/ageingReportConstant";
import {
  getAgeingReportDetailsByPaymentClass,
  getAgeingReportDetailsByRegionNew,
  getAgeingReportDetailsByStateNew,
} from "../../api/ageingReportService";
import CommonLoader from "../../common/commonLoader";
import { Bar, Line } from "react-chartjs-2";
import { Chart } from "react-google-charts";
import { formatMoney } from "../../../constants/utils";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import { Box } from "@mui/material";
import CommonTableWithFooterFixed from "../../common/commonTableWithFooterFixed";
import BlinkingText from "../../common/blinkingText";
import {
  newAgeingReportbyRegionTableData,
  newAgeingReportbyRegionTableDataMain,
  newAgeingReportbyRegionTableHeader,
  newAgeingReportbyRegionTableHeaderMain,
  agingReportbyStateTableData,
  agingReportbyStateTableDataMainView,
  agingReportbyStateTableHeader,
  agingReportbyStateTableHeaderMainView,
} from "../../common/ageingReportConstant";

const useStyles = makeStyles((theme) => ({
  btnClass: {
    padding: "0.5rem 1.5rem!important",
    fontWeight: 600,
  },

  btnJust: {
    display: "flex!important",
    justifyContent: "end!important",
  },

  cardbody: {
    padding: `${theme.spacing(1.8, 1.3)} !important`,
    [theme.breakpoints.down("sm")]: {
      padding: `${theme.spacing(0)} !important`,
      margin: `${theme.spacing(0, 1)} !important`,
    },
  },

  muiGrid: {
    marginTop: "-2vh",
    [theme.breakpoints.down("sm")]: {
      lineHeight: 5,
    },
  },
}));

const status = [
  {
    value: "Pending",
    label: "Pending",
  },
  {
    value: "Approved",
    label: "Approved",
  },
  {
    value: "Reject",
    label: "Reject",
  },
];

const AgeingReportLiveSection = (props) => {
  const {
    agingReportDataByState,
    agingReportDataByRegion,
    divisionNameForBlink,
    inactiveDtoListByRegion,
    dtoListByRegionOdMoreThan150,
    inactiveDtoListByState,
    dtoListByStateOdMoreThan150,
    dtoListByPaymentClass,
    searchData,
    selectedDivisionName,
  } = props;
  /*  const lineData = {
    labels: ["West", "East", "North", "South"],
    datasets: [
      {
        data: [2.5, 3, 3, 0.9, 1.3, 1.8, 3.8, 1.5],
        borderColor: "#ff8084",
        backgroundColor: "#ff8084",
        borderWidth: 2,
        barPercentage: 0.7,
        categoryPercentage: 0.4,
      },
      {
        data: [3.8, 1.8, 4.3, 2.3, 3.6, 2.8, 2.8, 2.8],
        borderColor: "#a5a5a5",
        backgroundColor: "#a5a5a5",
        borderWidth: 2,
        barPercentage: 0.7,
        categoryPercentage: 0.4,
      },
    ],
  }; */

  const barChartDataByRegionOptions = {
    maintainAspectRatio: false,
    responsive: true,

    animation: true,
    plugins: {
      legend: {
        display: true,
      },
    },
    scales: {
      xAxes: {
        barPercentage: 0.7,
        categoryPercentage: 0.4,
        gridLines: {
          display: false,
        },
      },
      yAxes: {
        barPercentage: 0.7,
        categoryPercentage: 0.4,
      },
    },
    /* scales: {
      x: {
        grid: {
          display: false,
        },
      },
      y: {
        beginAtZero: true,
      },
    }, */
  };

  const lineOptionsByState = {
    maintainAspectRatio: false,
    responsive: true,
    plugins: {
      legend: {
        display: true,
        position: "top",
      },
    },
    scales: {
      x: {
        grid: {
          display: false,
        },
      },
      y: {
        beginAtZero: true,
      },
    },
  };

  const classes = useStyles();

  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(25);

  const [modalData, setModalData] = useState([]);
  const [modalDataWithoutDivision, setModalDataWithoutDivision] = useState([]);
  const [rowData, setRowData] = useState(null);
  const [isRegion, setIsRegion] = useState(false);
  const [isPaymentClass, setIsPaymentClass] = useState(false);
  const [loading, setLoading] = useState(false);

  const [activeTab, setActiveTab] = useState("1");

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  const agingReportDataByRegionWithoutTotal = agingReportDataByRegion.filter(
    ({ regionName }) =>
      regionName?.toLowerCase() !== "total" &&
      regionName?.toLowerCase() !== "not mapped",
  );

  const labels = agingReportDataByRegionWithoutTotal.map(
    (item) => item.regionName,
  );
  const statelabels = agingReportDataByState.map((item) => item.stateName);
  const [showDetailedView, setShowDetailedView] = useState(false);
  const [showDetailedViewState, setShowDetailedViewState] = useState(false);
  const lineDataByState = {
    statelabels,
    datasets: [
      {
        label: "Total Net Balance",
        data: agingReportDataByState.map((item) => item.totalNetBalance),
        backgroundColor: "rgba(75, 192, 192, 0.6)", // Greenish-blue color
        borderColor: "rgba(75, 192, 192, 1)",
        borderWidth: 1,
      },
    ],
  };

  const barChartDataByDataRegion = {
    labels,
    datasets: [
      {
        label: "Overdue",
        data: agingReportDataByRegionWithoutTotal.map(
          (item) => item.totalOverdue,
        ),
        borderColor: "#da0000",
        backgroundColor: "#da0000",
        //backgroundColor: "rgb(218, 0, 0)",
        borderWidth: 2,
      },
      {
        label: "Provision Amount",
        data: agingReportDataByRegionWithoutTotal.map(
          (item) => item.totalProvisionAmount,
        ),
        borderColor: "#d69e11",
        backgroundColor: "#d69e11",
        //backgroundColor: "rgb(218, 0, 0)",
        borderWidth: 2,
      } /*
      /*,
      {
        label: "Days 0-30",
        data: agingReportDataByRegion.map((item) => item.totalDays0_30),
        borderColor: "#2a863f",
        backgroundColor: "#2a863f",
        borderWidth: 2,
      },
      {
        label: "Days 31-45",
        data: agingReportDataByRegion.map((item) => item.totalDays31_60),
        borderColor: "#d69e11",
        backgroundColor: "#d69e11",
        borderWidth: 2,
      },
      {
        label: "Days 46-61",
        data: agingReportDataByRegion.map((item) => item.totalDays61_150),
        borderColor: "#b255ec",
        backgroundColor: "#b255ec",
        borderWidth: 2,
      },
      {
        label: "Days 61-90",
        data: agingReportDataByRegion.map((item) => item.totalDays151_180),
        borderColor: "#0e87d7",
        backgroundColor: "#0e87d7",
        borderWidth: 2,
      },
      {
        label: "Days 91-180",
        data: agingReportDataByRegion.map((item) => item.totalDays181_330),
        borderColor: "#111b75",
        backgroundColor: "#111b75",
        borderWidth: 2,
      },
      {
        label: "Days 181-365",
        data: agingReportDataByRegion.map((item) => item.totalDays331_365),
        borderColor: "#65233b",
        backgroundColor: "#65233b",
        borderWidth: 2,
      },
      {
        label: "Days >365",
        data: agingReportDataByRegion.map(
          (item) => item.totalDaysGreaterThan_365
        ),
        borderColor: "#da4100",
        backgroundColor: "#da4100",
        //backgroundColor: "rgb(218, 65, 0)",
        borderWidth: 2,
      } */,
      /*{
        label: "Net Balance",
        data: agingReportDataByRegion.map((item) => item.totalNetBalance),
        borderColor: "#ff8084",
        backgroundColor: "#ff8084",
        borderWidth: 2,
      }, */
    ],
  };

  /* const buyData = {
    labels: ["", "10", "20", "30", "40", "50"],
    datasets: [
      {
        backgroundColor: "transparent",
        borderColor: "#13c9ca",
        data: [20, 5, 80, 10, 100, 15],
        lineTension: 0.4,
      },
      {
        backgroundColor: "transparent",
        borderColor: "#a5a5a5",
        data: [0, 50, 20, 70, 30, 27],
        lineTension: 0.4,
      },
      {
        backgroundColor: "transparent",
        borderColor: "#ff8084",
        data: [0, 30, 40, 10, 86, 40],
        lineTension: 0.4,
      },
    ],
  }; */

  const processChartData = (data) => {
    // Extract unique months (x-axis labels)
    const months = [...new Set(data.map((item) => item.monthName))];

    // Extract unique regions
    const regions = [...new Set(data.map((item) => item.regionName))];

    // Create datasets for each region
    const datasets = regions.map((region) => ({
      label: region,
      backgroundColor: "transparent",
      borderColor: getColor(region),
      pointBackgroundColor: getColor(region),
      data: months.map((month) => {
        const entry = data.find(
          (item) => item.monthName === month && item.regionName === region,
        );
        return entry ? entry.totalOverdue : 0; // Default to 0 if missing
      }),
      lineTension: 0.4,
    }));
    return { labels: months, datasets };
  };

  // Function to assign colors dynamically
  const getColor = (region) => {
    const colorMap = {
      West: "#0e87d7",
      North: "#b255ec",
      East: "#a6b90e",
      South: "#d7600e",
    };
    return colorMap[region];
  };

  const [open, setOpen] = useState(false);

  const onOpenModalRegion = (row) => {
    setIsRegion(true);
    setLoading(true);
    const divisionId = searchData.searchDivision ?? "";
    const asmLoginId = searchData.searchAsm ?? "";
    getAgeingReportDetailsByRegionNew(
      row.regionMasterId,
      divisionId,
      asmLoginId,
    ).then((res) => {
      setLoading(false);
      setModalData(res.response.responseMap.ageingReportsWithDivisionByRegion);
      setModalDataWithoutDivision(
        res.response.responseMap.ageingReportsWithoutDivisionByRegion,
      );
      console.log(res.response.responseMap, "res.response.responseMap");
      //setOpen
      setRowData(row);
      setOpen(true);
    });
  };

  const onOpenModalRegionInactive = (row) => {
    setIsRegion(true);
    setLoading(true);
    const divisionId = searchData.searchDivision ?? "";
    const asmLoginId = searchData.searchAsm ?? "";
    getAgeingReportDetailsByRegionNew(
      row.regionMasterId,
      divisionId,
      asmLoginId,
      "Inactive",
    ).then((res) => {
      setLoading(false);
      setModalData(res.response.responseMap.ageingReportsWithDivisionByRegion);
      setModalDataWithoutDivision(
        res.response.responseMap.ageingReportsWithoutDivisionByRegion,
      );
      //setOpen
      setRowData(row);
      setOpen(true);
    });
  };

  const onOpenModalRegionODMoreThan150 = (row) => {
    setIsRegion(true);
    setLoading(true);
    const divisionId = searchData.searchDivision ?? "";
    const asmLoginId = searchData.searchAsm ?? "";
    getAgeingReportDetailsByRegionNew(
      row.regionMasterId,
      divisionId,
      asmLoginId,
      "OD More Than 150",
    ).then((res) => {
      setLoading(false);
      setModalData(res.response.responseMap.ageingReportsWithDivisionByRegion);
      setModalDataWithoutDivision(
        res.response.responseMap.ageingReportsWithoutDivisionByRegion,
      );
      console.log(res.response.responseMap, "res.response.responseMap");
      //setOpen
      setRowData(row);
      setOpen(true);
    });
  };

  const onOpenModalState = (row) => {
    setIsRegion(false);
    if (row.stateMasterId) {
      setLoading(true);
      const divisionId = searchData.searchDivision ?? "";
      const asmLoginId = searchData.searchAsm ?? "";
      getAgeingReportDetailsByStateNew(
        row.stateMasterId,
        divisionId,
        asmLoginId,
      ).then((res) => {
        setLoading(false);
        //setModalData(res.response.responseObject);
        setModalData(res.response.responseMap.ageingReportsWithDivisionByState);
        setModalDataWithoutDivision(
          res.response.responseMap.ageingReportsWithoutDivisionByState,
        );
        setRowData(row);
        setOpen(true);
      });
    }
  };

  const onOpenModalStateInactive = (row) => {
    setIsRegion(false);
    if (row.stateMasterId) {
      setLoading(true);
      const divisionId = searchData.searchDivision ?? "";
      const asmLoginId = searchData.searchAsm ?? "";
      getAgeingReportDetailsByStateNew(
        row.stateMasterId,
        divisionId,
        asmLoginId,
        "Inactive",
      ).then((res) => {
        setLoading(false);
        //setModalData(res.response.responseObject);
        setModalData(res.response.responseMap.ageingReportsWithDivisionByState);
        setModalDataWithoutDivision(
          res.response.responseMap.ageingReportsWithoutDivisionByState,
        );
        setRowData(row);
        setOpen(true);
      });
    }
  };

  const onOpenModalStateODMoreThan150 = (row) => {
    setIsRegion(false);
    if (row.stateMasterId) {
      setLoading(true);
      const divisionId = searchData.searchDivision ?? "";
      const asmLoginId = searchData.searchAsm ?? "";
      getAgeingReportDetailsByStateNew(
        row.stateMasterId,
        divisionId,
        asmLoginId,
        "OD More Than 150",
      ).then((res) => {
        setLoading(false);
        //setModalData(res.response.responseObject);
        setModalData(res.response.responseMap.ageingReportsWithDivisionByState);
        setModalDataWithoutDivision(
          res.response.responseMap.ageingReportsWithoutDivisionByState,
        );
        setRowData(row);
        setOpen(true);
      });
    }
  };

  const onOpenModalPaymentClass = (row) => {
    setIsPaymentClass(true);
    setLoading(true);
    const divisionId = selectedDivisionName ?? "";
    const asmLoginId = searchData.searchAsm ?? "";

    console.log(searchData, "searchData");
    getAgeingReportDetailsByPaymentClass(
      row.paymentClass,
      divisionId,
      asmLoginId,
    ).then((res) => {
      setLoading(false);
      setModalData(
        res.response.responseMap.ageingReportsWithDivisionByPaymentClass,
      );
      setModalDataWithoutDivision(
        res.response.responseMap.ageingReportsWithoutDivisionByPaymentClass,
      );
      //setOpen
      setRowData(row);
      setOpen(true);
    });
  };

  const handleChangePage = (newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(event.target.value);
    setPage(0);
  };

  const slabels = agingReportDataByState.map((item) => item.stateName);
  const filteredDataByState = agingReportDataByState.filter(
    (item) => item.totalOverdue > 0,
  );
  const netBalancesByState = filteredDataByState.map(
    (item) => item.totalOverdue,
  );
  // 27 unique background colors
  const backgroundColors = [
    "#1a139f",
    "#ff6384",
    "#36a2eb",
    "#ffce56",
    "#4bc0c0",
    "#9966ff",
    "#ff9f40",
    "#e74c3c",
    "#2ecc71",
    "#f39c12",
    "#9b59b6",
    "#8e44ad",
    "#2c3e50",
    "#d35400",
    "#16a085",
    "#c0392b",
    "#7f8c8d",
    "#e67e22",
    "#2980b9",
    "#f1c40f",
    "#27ae60",
    "#34495e",
    "#dc7633",
    "#f1948a",
    "#5dade2",
    "#58d68d",
    "#d5dbdb",
  ].slice(0, slabels.length);
  const barDataByState = {
    labels: slabels,
    datasets: [
      {
        label: "Overdue",
        data: netBalancesByState,
        backgroundColor: backgroundColors, //"#1a139f", // Greenish-blue color
        borderColor: backgroundColors, //,"#1a139f", // Greenish-blue color
        //borderColor: "rgba(75, 192, 192, 1)",
        borderWidth: 1,
      },
    ],
  };

  const barOptionsByState = {
    maintainAspectRatio: false,
    responsive: true,
    plugins: {
      legend: {
        display: true,
        position: "top",
      },
    },
    scales: {
      x: {
        grid: {
          display: false,
        },
      },
      y: {
        beginAtZero: true,
      },
    },
  };

  const pieOptionsForState = {
    title: "Overdue by State",
    titleTextStyle: { fontSize: 16, bold: true }, // Customize title style
    pieHole: 0.4, // Semi-donut effect
    slices: agingReportDataByState.map((_, index) => ({
      color: backgroundColors[index],
    })),
    tooltip: { showColorCode: true },
    chartArea: { left: 10, top: 10, width: "100%", height: "100%" },
    //legend: { position: "right" },
    legend: "none", // Hides the legend
    width: 400, // adjust width
    height: 400, // adjust height
    //legend: { position: "right" },
  };

  const pieChartData = [
    ["State", "Total Overdue"],
    ...agingReportDataByState
      .filter(
        ({ stateName, totalOverdue }) =>
          stateName?.toLowerCase() !== "total" && totalOverdue > 0,
      ) // filter out total
      .map(({ stateName, totalOverdue }) => [stateName, totalOverdue]),
  ];

  const stateTotalOverDue = agingReportDataByState.filter(
    ({ stateName }) => stateName?.toLowerCase() === "total",
  )[0]?.totalOverdue;

  const regionTotalOverDue = agingReportDataByRegion.filter(
    ({ regionName }) => regionName?.toLowerCase() === "total",
  )[0]?.totalOverdue;

  //const regionTotalOverDue = `${regionTotalOverDueVal / 10000000} Cr`;

  return (
    <Fragment>
      {loading ? <CommonLoader /> : null}
      {/* <!-- Container-fluid starts--> */}
      <Container fluid={true}>
        <Row>
          <TabContext value={activeTab}>
            <TabList
              onChange={handleTabChange}
              aria-label="lab API tabs example"
              indicatorColor="secondary"
              textColor="secondary"
              style={{ background: "white" }}
            >
              <Tab label="By Region" value="1" />
              <Tab label="By State" value="2" />
            </TabList>
            {/* By Region Section Starts*/}
            <TabPanel value="1">
              <Card>
                {/* <CardHeader
                  style={{
                    padding: "10px 10px 0px",
                  }}
                >
                  <h5>Live Details</h5>
                </CardHeader> */}
                <CardBody className={classes.cardbody}>
                  {regionTotalOverDue && (
                    <BlinkingText
                      value={`Total Overdue Rs. ${formatMoney(
                        regionTotalOverDue,
                      )} (${divisionNameForBlink})`}
                    />
                  )}
                  <div className="market-chart">
                    <Bar
                      data={barChartDataByDataRegion}
                      options={barChartDataByRegionOptions}
                      width={778}
                      height={308}
                    />
                  </div>
                  <div>
                    <Box display={"flex"}>
                      <Button
                        style={{ marginLeft: 10, marginBottom: 10, width: 250 }}
                        color="dark"
                        variant="contained"
                        type="button"
                        onClick={() => setShowDetailedView(!showDetailedView)}
                      >
                        {`View ${!showDetailedView ? "Detailed" : "Main"} data`}
                      </Button>
                    </Box>

                    <CardHeader
                      style={{
                        padding: "0px 0px 10px",
                      }}
                    >
                      <h5 style={{ color: "#f91d25" }}>Payment Class</h5>
                    </CardHeader>

                    <CommonTableWithFooterFixed
                      tableData={dtoListByPaymentClass.filter(
                        ({ paymentClass }) =>
                          paymentClass?.toLowerCase() !== "total",
                      )}
                      tableHeaders={
                        showDetailedView
                          ? agingReportbyPaymentClassTableHeader
                          : agingReportbyPaymentClassTableHeaderMain
                      }
                      tableColumns={
                        showDetailedView
                          ? agingReportbyPaymentClassTableData
                          : agingReportbyPaymentClassTableDataMain
                      }
                      editId={"paymentClass"}
                      editMode={true}
                      onOpenModal={onOpenModalPaymentClass}
                      rowsPerPageOptions={[25, 50, 100]}
                      count={dtoListByRegionOdMoreThan150.length}
                      rowsPerPage={rowsPerPage}
                      page={page}
                      onPageChange={handleChangePage}
                      onRowsPerPageChange={handleChangeRowsPerPage}
                      sx={{ float: "right" }}
                      displayPagination={false}
                      tableFooterData={dtoListByPaymentClass.filter(
                        ({ paymentClass }) =>
                          paymentClass?.toLowerCase() === "total",
                      )}
                    />

                    <CardHeader
                      style={{
                        padding: "0px 0px 10px",
                      }}
                    >
                      <h5 style={{ color: "#f91d25" }}>By Region</h5>
                    </CardHeader>
                    <CommonTableWithFooterFixed
                      tableData={agingReportDataByRegion.filter(
                        ({ regionName }) =>
                          regionName?.toLowerCase() !== "total",
                      )}
                      tableHeaders={
                        showDetailedView
                          ? newAgeingReportbyRegionTableHeader
                          : newAgeingReportbyRegionTableHeaderMain
                      }
                      tableColumns={
                        showDetailedView
                          ? newAgeingReportbyRegionTableData
                          : newAgeingReportbyRegionTableDataMain
                      }
                      editId={"regionMasterId"}
                      editMode={true}
                      onOpenModal={onOpenModalRegion}
                      rowsPerPageOptions={[25, 50, 100]}
                      count={agingReportDataByRegion.length}
                      rowsPerPage={rowsPerPage}
                      page={page}
                      onPageChange={handleChangePage}
                      onRowsPerPageChange={handleChangeRowsPerPage}
                      sx={{ float: "right" }}
                      displayPagination={false}
                      tableFooterData={agingReportDataByRegion.filter(
                        ({ regionName }) =>
                          regionName?.toLowerCase() === "total",
                      )}
                    />

                    {/* <CardHeader
                      style={{
                        padding: "0px 0px 10px",
                      }}
                    >
                      <h5 style={{ color: "#f91d25" }}>In-active Users Data</h5>
                    </CardHeader>

                    <CommonTableWithFooterFixed
                      tableData={inactiveDtoListByRegion.filter(
                        ({ regionName }) =>
                          regionName?.toLowerCase() !== "total"
                      )}
                      tableHeaders={
                        showDetailedView
                          ? newAgeingReportbyRegionTableHeader
                          : newAgeingReportbyRegionTableHeaderMain
                      }
                      tableColumns={
                        showDetailedView
                          ? newAgeingReportbyRegionTableData
                          : newAgeingReportbyRegionTableDataMain
                      }
                      editId={"regionMasterId"}
                      editMode={true}
                      onOpenModal={onOpenModalRegionInactive}
                      rowsPerPageOptions={[25, 50, 100]}
                      count={inactiveDtoListByRegion.length}
                      rowsPerPage={rowsPerPage}
                      page={page}
                      onPageChange={handleChangePage}
                      onRowsPerPageChange={handleChangeRowsPerPage}
                      sx={{ float: "right" }}
                      displayPagination={false}
                      tableFooterData={inactiveDtoListByRegion.filter(
                        ({ regionName }) =>
                          regionName?.toLowerCase() === "total"
                      )}
                    />

                    <CardHeader
                      style={{
                        padding: "0px 0px 10px",
                      }}
                    >
                      <h5 style={{ color: "#f91d25" }}>
                        Parties with Overdue More than 150 days
                      </h5>
                    </CardHeader>

                    <CommonTableWithFooterFixed
                      tableData={dtoListByRegionOdMoreThan150.filter(
                        ({ regionName }) =>
                          regionName?.toLowerCase() !== "total"
                      )}
                      tableHeaders={
                        showDetailedView
                          ? newAgeingReportbyRegionTableHeader
                          : newAgeingReportbyRegionTableHeaderMain
                      }
                      tableColumns={
                        showDetailedView
                          ? newAgeingReportbyRegionTableData
                          : newAgeingReportbyRegionTableDataMain
                      }
                      editId={"regionMasterId"}
                      editMode={true}
                      onOpenModal={onOpenModalRegionODMoreThan150}
                      rowsPerPageOptions={[25, 50, 100]}
                      count={dtoListByRegionOdMoreThan150.length}
                      rowsPerPage={rowsPerPage}
                      page={page}
                      onPageChange={handleChangePage}
                      onRowsPerPageChange={handleChangeRowsPerPage}
                      sx={{ float: "right" }}
                      displayPagination={false}
                      tableFooterData={dtoListByRegionOdMoreThan150.filter(
                        ({ regionName }) =>
                          regionName?.toLowerCase() === "total"
                      )}
                    /> */}
                  </div>
                </CardBody>
              </Card>
            </TabPanel>
            {/* By Region Section Ends*/}
            {/* By State Section Starts*/}
            <TabPanel value="2">
              {" "}
              <Row>
                <Col sm="12">
                  <Card>
                    <CardHeader style={{ padding: "10px 30px" }}>
                      <h5>Live Data by State</h5>
                    </CardHeader>
                    <CardBody>
                      <Row>
                        <Col xl="5 xl-50" sm="12">
                          <div className="order-graph sm-order-space">
                            <div className="order-graph-bottom sales-location">
                              <Media>
                                <div
                                  className="order-shape-primary"
                                  style={{
                                    backgroundColor: "#000",
                                  }}
                                ></div>
                                <Media body>
                                  <h6
                                    className="mb-0 me-0"
                                    style={{ color: "black", fontSize: 18 }}
                                  >
                                    {`Total Overdue `}
                                    <span style={{ marginLeft: 30 }}>
                                      {formatMoney(stateTotalOverDue)}
                                    </span>
                                  </h6>
                                </Media>
                              </Media>
                            </div>
                          </div>
                          <div className="order-graph sm-order-space">
                            <div className="peity-chart-dashboard text-center">
                              <Chart
                                chartType="PieChart"
                                data={pieChartData}
                                options={pieOptionsForState}
                                graph_id="PieChart"
                                width={"400px"} // Increase width
                                height={"400px"}
                                //legend_toggle
                              />
                            </div>
                          </div>
                        </Col>
                        <Col
                          xl="7 xl-50"
                          sm="12"
                          //style={{ height: 500, overflow: "scroll" }}
                        >
                          <Row>
                            <Col xl="6 xl-50" sm="12">
                              {" "}
                              <div className="order-graph sm-order-space">
                                <Media body>
                                  <h6 className="mb-0 me-0">
                                    {`State`}
                                    <span className="pull-right">{`Overdue`}</span>
                                  </h6>
                                </Media>
                                <div
                                  className="order-graph-bottom sales-location"
                                  style={{ height: 440, overflow: "scroll" }}
                                >
                                  {agingReportDataByState
                                    .filter(
                                      ({ stateName }) =>
                                        stateName?.toLowerCase() !== "total",
                                    ) // filter out total
                                    .slice(0, 13)
                                    .map((item, index) => {
                                      return (
                                        <Media>
                                          <div
                                            className="order-shape-primary"
                                            style={{
                                              backgroundColor:
                                                backgroundColors[index],
                                            }}
                                          ></div>
                                          <Media body>
                                            <h6 className="mb-0 me-0">
                                              {`${item.stateName} `}
                                              <span className="pull-right">
                                                {item.totalOverdue > 0
                                                  ? formatMoney(
                                                      item.totalOverdue,
                                                    )
                                                  : 0}
                                              </span>
                                            </h6>
                                          </Media>
                                        </Media>
                                      );
                                    })}
                                </div>
                              </div>
                            </Col>
                            {agingReportDataByState.length > 13 && (
                              <Col
                                xl="6 xl-50"
                                sm="6"
                                //style={{ height: 500, overflow: "scroll" }}
                              >
                                {" "}
                                <div className="order-graph sm-order-space">
                                  <Media body>
                                    <h6 className="mb-0 me-0">
                                      {`State`}
                                      <span className="pull-right">{`Overdue`}</span>
                                    </h6>
                                  </Media>
                                  <div
                                    className="order-graph-bottom sales-location"
                                    style={{ height: 440, overflow: "scroll" }}
                                  >
                                    {agingReportDataByState
                                      .filter(
                                        ({ stateName }) =>
                                          stateName?.toLowerCase() !== "total",
                                      ) // filter out total
                                      .slice(13)
                                      .map((item, index) => {
                                        return (
                                          <Media>
                                            <div
                                              className="order-shape-primary"
                                              style={{
                                                backgroundColor:
                                                  backgroundColors[index + 14],
                                              }}
                                            ></div>
                                            <Media body>
                                              <h6 className="mb-0 me-0">
                                                {`${item.stateName} `}
                                                <span className="pull-right">
                                                  {item.totalOverdue > 0
                                                    ? formatMoney(
                                                        item.totalOverdue,
                                                      )
                                                    : 0}
                                                </span>
                                              </h6>
                                            </Media>
                                          </Media>
                                        );
                                      })}
                                  </div>
                                </div>
                              </Col>
                            )}
                          </Row>
                        </Col>
                      </Row>
                    </CardBody>
                  </Card>
                </Col>
                <Card>
                  {/*  <CardHeader
                    style={{
                      padding: "10px 30px 0px",
                    }}
                  >
                    <h5>By State</h5>
                  </CardHeader> */}
                  <CardBody className={classes.cardbody}>
                    {/* <div className="market-chart">
                      <Bar
                        data={barDataByState}
                        options={barOptionsByState}
                        width={778}
                        height={308}
                      />
                    </div> */}
                    <div>
                      <Box display={"flex"}>
                        <Button
                          style={{
                            marginLeft: 10,
                            marginBottom: 4,
                            width: 250,
                          }}
                          color="dark"
                          variant="contained"
                          type="button"
                          onClick={() =>
                            setShowDetailedViewState(!showDetailedViewState)
                          }
                        >
                          {`View ${
                            !showDetailedViewState ? "Detailed" : "Main"
                          } data`}
                        </Button>
                      </Box>
                      <CommonTableWithFooterFixed
                        tableData={agingReportDataByState.filter(
                          ({ stateName }) =>
                            stateName?.toLowerCase() !== "total",
                        )}
                        tableHeaders={
                          showDetailedViewState
                            ? agingReportbyStateTableHeader
                            : agingReportbyStateTableHeaderMainView
                        }
                        tableColumns={
                          showDetailedViewState
                            ? agingReportbyStateTableData
                            : agingReportbyStateTableDataMainView
                        }
                        editId={"stateMasterId"}
                        editMode={true}
                        onOpenModal={onOpenModalState}
                        rowsPerPageOptions={[25, 50, 100]}
                        count={agingReportDataByState.length}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        onPageChange={handleChangePage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                        sx={{ float: "right" }}
                        displayPagination={false}
                        tableFooterData={agingReportDataByState.filter(
                          ({ stateName }) =>
                            stateName?.toLowerCase() === "total",
                        )}
                      />
                      {/* <CardHeader
                        style={{
                          padding: "0px 0px 10px",
                        }}
                      >
                        <h5 style={{ color: "#f91d25" }}>
                          In-active Users Data
                        </h5>
                      </CardHeader>

                      <CommonTableWithFooterFixed
                        tableData={inactiveDtoListByState.filter(
                          ({ stateName }) =>
                            stateName?.toLowerCase() !== "total"
                        )}
                        tableHeaders={
                          showDetailedViewState
                            ? agingReportbyStateTableHeader
                            : agingReportbyStateTableHeaderMainView
                        }
                        tableColumns={
                          showDetailedViewState
                            ? agingReportbyStateTableData
                            : agingReportbyStateTableDataMainView
                        }
                        editId={"stateMasterId"}
                        editMode={true}
                        onOpenModal={onOpenModalStateInactive}
                        rowsPerPageOptions={[25, 50, 100]}
                        count={inactiveDtoListByState.length}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        onPageChange={handleChangePage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                        sx={{ float: "right" }}
                        displayPagination={false}
                        tableFooterData={inactiveDtoListByState.filter(
                          ({ stateName }) =>
                            stateName?.toLowerCase() === "total"
                        )}
                      />

                      <CardHeader
                        style={{
                          padding: "0px 0px 10px",
                        }}
                      >
                        <h5 style={{ color: "#f91d25" }}>
                          Parties with Overdue More than 150 days
                        </h5>
                      </CardHeader>

                      <CommonTableWithFooterFixed
                        tableData={dtoListByStateOdMoreThan150.filter(
                          ({ stateName }) =>
                            stateName?.toLowerCase() !== "total"
                        )}
                        tableHeaders={
                          showDetailedViewState
                            ? agingReportbyStateTableHeader
                            : agingReportbyStateTableHeaderMainView
                        }
                        tableColumns={
                          showDetailedViewState
                            ? agingReportbyStateTableData
                            : agingReportbyStateTableDataMainView
                        }
                        editId={"stateMasterId"}
                        editMode={true}
                        onOpenModal={onOpenModalStateODMoreThan150}
                        rowsPerPageOptions={[25, 50, 100]}
                        count={dtoListByStateOdMoreThan150.length}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        onPageChange={handleChangePage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                        sx={{ float: "right" }}
                        displayPagination={false}
                        tableFooterData={dtoListByStateOdMoreThan150.filter(
                          ({ stateName }) =>
                            stateName?.toLowerCase() === "total"
                        )}
                      /> */}
                    </div>
                  </CardBody>
                </Card>
              </Row>
            </TabPanel>
            {/* By State Section Ends*/}
          </TabContext>
        </Row>

        <AgeingReportModal
          open={open}
          onCancel={() => {
            setOpen(false);
            setRowData(null);
            setModalData([]);
            setModalDataWithoutDivision([]);
            setIsRegion(false);
            setIsPaymentClass(false);
          }}
          modalData={modalData}
          modalDataWithoutDivision={modalDataWithoutDivision}
          title={`${
            rowData &&
            (isPaymentClass
              ? `DB Class: ${rowData.paymentClass}`
              : isRegion
                ? rowData?.regionName
                : rowData?.stateName)
          } - Ageing Report`}
        />
      </Container>
      {/* <!-- Container-fluid Ends--> */}
      <ToastContainer autoClose={1000} />
    </Fragment>
  );
};

export default AgeingReportLiveSection;
